module.exports = __webpack_public_path__ + "img/Pravoslanica_marturisire_Buzau_1691.28da240c.jpg";